import * as Sentry from "@sentry/react";
import type { User } from "./api/types";

export const init = (): void => {
  // no DSN, no Sentry: local runs and the test suite send nothing
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    // errors only
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
  Sentry.setTag("service", "frontend");
};

export const reportApiError = (
  method: string,
  url: string,
  status: number,
  message: string,
): void => {
  // a plain Error: the AxiosError carries the request headers, token included
  Sentry.captureException(new Error(`API error: ${message}`), {
    tags: { method: method.toUpperCase(), url, status },
  });
};

export const setUser = (user: User | null): void => {
  // field by field: the user holds email and phone
  Sentry.setUser(user && { id: user.id, username: user.username });
  Sentry.setTag("role", user?.role);
};
